import { render, staticRenderFns } from "./notifications-dialog.vue?vue&type=template&id=780e2b3a&scoped=true&"
import script from "./notifications-dialog.vue?vue&type=script&lang=js&"
export * from "./notifications-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780e2b3a",
  null
  
)

export default component.exports